import request from "./request";
/**
 * 删除发布队列信息
 * @param data 记录id数组
 */
export default async function batchDeleteSendQueue(data) {
  return await request.post("/spin/dataSend/batchDeleteSendQueue", data);
}
